// `mapNewBrain` moved verbatim from `src/utils/brainUtils.ts` (which
// re-exports it and keeps its other, UI-facing exports) with the D3 family —
// the session fetch core normalizes `consult_note.brain` through it. Pure
// over the schema enum. Re-homing it with a notes/templates package is a
// named follow-up (task Z3), not a move concern.
import { Brain } from '@heidi/schema/ml-scribe';

// Helper function to map new brain options to old brain options
// Backwards compatibility: handles old FREE, PRO, REASONING values.
// `isFreeUser` is unused by the mapping (kept optional for existing call sites).
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function mapNewBrain<T>(brain: T, isFreeUser?: boolean): Brain | T {
  if (brain === Brain.FREE) {
    return Brain.LEFT;
  } else if (brain === Brain.PRO) {
    return Brain.LEFT;
  } else if (brain === Brain.REASONING) {
    return Brain.RIGHT;
  } else {
    return brain;
  }
}
